/*
  pp-pickup.js: Ergaenzt das Abhol-Popup um zwei Verhalten, die das
  Dawn-Skript (assets/pickup-availability.js) nicht mitbringt, weil es dort
  ein seitliches Panel war und kein zentriertes Popup:

  1. Klick auf die abgedunkelte Flaeche schliesst das Popup.
     Dawns handleBodyClick prueft "target != this", ein Klick auf das
     Overlay IST aber das Element selbst und wuerde ignoriert.
  2. Escape schliesst auch dann, wenn der Fokus nicht im Popup liegt.

  Delegiert auf document-Ebene, weil das Popup erst nach einem fetch in den
  body gehaengt wird und dabei mehrfach ausgetauscht werden kann.
*/
(function () {
  'use strict';
  if (window.__ppPickupInit) return;
  window.__ppPickupInit = true;

  function openDrawer() {
    var d = document.querySelector('pickup-availability-drawer[open]');
    return d && typeof d.hide === 'function' ? d : null;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || target.tagName !== 'PICKUP-AVAILABILITY-DRAWER') return;
    if (!target.hasAttribute('open') || typeof target.hide !== 'function') return;
    target.hide();
  });

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape' && event.code !== 'Escape') return;
    var d = openDrawer();
    if (d) d.hide();
  });
})();
